// extracted by mini-css-extract-plugin
export default {"quote":"style-module--quote--f6566"};